export default __webpack_public_path__ + "static/media/serverNotConnected.2dabaf2e.png";